import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import styled from 'styled-components'

const Page = styled.span`
  position: relative;
  display: block;
  padding: .5rem .75rem;
  margin-left: -1px;
  line-height: 1.25;
`

const Paginator = ({ pageContext }) => {
  const { currentPage, numPages, prevPath, nextPath } = pageContext
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-lg-12 center-content margin-tb-30px'>
          <ul className='pagination pagination-md pagination-style-1 color'>
            <li><Link className={`page-link ${isFirst && 'disabled-link'}`} to={prevPath} rel='prev'><i className='fa fa-chevron-left' /></Link></li>
            <li><Page> {currentPage} / {numPages}</Page></li>
            <li><Link className={`page-link ${isLast && 'disabled-link'}`} to={nextPath} rel='next'><i className='fa fa-chevron-right' /></Link></li>
          </ul>
        </div>
      </div>
    </div>
  )
}

Paginator.propTypes = {
  pageContext: PropTypes.shape()

}

Paginator.defaultProps = {
  pageContext: {}
}

export default Paginator
